import Vue from 'vue'
import Vuex from 'vuex'
import control from "./modules/control"
import us3 from "./modules/us3"
import storage from "./modules/storage"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    control,
    us3,
    storage,
  }
})
